import axios from 'axios'

 
export default {

    async checkAuth(params,callback){
        return await axios.post("/app/client/auth/checkauth",params)
        .then(res=>{
            callback(res)
        })
        .catch(err=>{
            console.log('response error '+err)
        })
    },

    async logOut(params,callback){
        return await axios.post("/app/client/auth/logout",params)
        .then(res=>{
            callback(res)
        })
        .catch(err=>{
            console.log('response error '+err)
        })
    },




}
 
